<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1.5rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M20 5v13.32A1.68 1.68 0 0118.32 20H15v-6.2h2.07l.32-2.41H15V9.84a1.29 1.29 0 01.29-.84 1.19 1.19 0 01.95-.29h1.27v-2.2a14.59 14.59 0 00-1.85-.09 3.08 3.08 0 00-2.27.83 3.14 3.14 0 00-.85 2.35v1.79h-2.08v2.41h2.08V20H5.68A1.68 1.68 0 014 18.32V5a1 1 0 011-1h14a1 1 0 011 1z"/></svg>